import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { AppConst } from 'src/app/core/_constants/app.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { CommonService } from 'src/app/core/_services/common.service';
import { MainService } from 'src/app/core/_services/main.service';
import { LocalStorageProvider } from 'src/app/core/_services/storage.service';
import { CollectSignatureComponent } from '../../dialogs/collect-signature/collect-signature.component';
import { ImageIncludeComponent } from '../../dialogs/image-include/image-include.component';

@Component({
  selector: 'app-estimate',
  templateUrl: './estimate.component.html',
  styleUrls: ['./estimate.component.scss']
})
export class EstimateComponent implements OnInit {
  public dateFormat = AppConst.DATE_FORMAT
  @Output() changeEstimateDetails = new EventEmitter();
  @Input() preview: any;
  @Input() estimates: any;
  @Input() inspection: boolean = false;
  @Input() optionalEstimates: any;
  @Input() review: any;
  @Input() hidePrice: any;
  @Input() lumpSum: any;
  @Input() approveAllFlag: boolean = false;
  @Input() work_order: boolean = false;
  @Input() set expandBundleId(id: string) {
    if (id) {
      this.expandedBundles.add(id);
    }
  }
  @Output() approveAllRejected = new EventEmitter<boolean>();

  @Output() isIncludeData = new EventEmitter()
  public includedEstimates: any;
  approveEstimateIds: any = []
  totalAmount: any;
  taxAmount: any;
  discountAmount: number = 0;
  viewerFlag: boolean = false;


  constructor(private router: Router,
    private storageService: LocalStorageProvider,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
    private service: MainService,
    private dialog: MatDialog
  ) { }

  isPreferredUser: boolean = false;
  location: boolean = false;
  ngOnInit(): void {
    this.isPreferredUser = this.storageService.getItem('CurrentUser')?.externalCompanyData?.isPreferred;
    this.getDefaultStatus();
    this.location = this.router.url.includes('review-estimate');
    if (this.router.url.includes('review-')) {
      this.viewerFlag = true;
    }
  }
  ngOnChanges(change: SimpleChanges) {
    this.setInitiallySelectedEstimateIds();
    this.totalAmount = this.calculateAmount('total');
    this.taxAmount = this.calculateAmount('tax')
    this.discountAmount = this.calculateDiscount();

    if (this.optionalEstimates) {
      this.includedEstimates = this.optionalEstimates;
    }
    if (change['approveAllFlag']?.currentValue) {
      this.approveEstimate();
    }
  }

  setInitiallySelectedEstimateIds() {
    if (this.review) {
      this.estimates.map((estimate: any) => {
        this.approveEstimateIds.push(estimate._id);
      });
    }
  }
  inspectionBtn: any = []
  getDefaultStatus() {
    this.service.get({}, `${API_ROUTES.OPPORTUNITY.getInspectionBtnStatus}`).pipe().subscribe(response => {
      console.log(response)
      if (response.status) {
        let initialData = response.data?.list;
        this.inspectionBtn = response.data?.list;
        this.estimates?.forEach((estimate) => {
          const foundEstimate = initialData.find((initial) => initial._id === estimate.inspectionId);
          if (foundEstimate) {
            estimate.inspectionStatus = foundEstimate.fieldName;
          }
        });
      }
    })
  }

  setInspectionStatus(id: number): string {
    console.log(id);
    const foundBtn = this.inspectionBtn?.find(ele => ele?._id === id);
    console.log(foundBtn, 'nwknkjwn')
    if (foundBtn) {
      // Apply class based on originalName
      switch (foundBtn.originalName) {
        case 'Fail':
          return 'red-btn';
        case 'Pass':
          return 'pass-status';
        case 'Pending':
          return 'pend-status';
        case 'N/A':
          return 'grey-btn';
        default:
          return '';
      }
    } else {
      return ''; // Default class if no button is found
    }
  }

  calculateAmount(key: any) {
    console.log(this.estimates, this.optionalEstimates)
    let total = 0.00;
    if (this.estimates) {
      let allEst = [...this.estimates, ...(this.optionalEstimates || [])]
      if (allEst && allEst.length) {
        allEst.map((order: any) => {
          if (order?.isInclude) {
            total = total + this.amountFor(order, key);
          }
        });
        return total.toFixed(2);
      }
    }
    return 0.00.toFixed(2);

  }

  // ================= Discount (read-only) =================
  // Items carry discountAmount / discountedTax / discountedTotal when a discount was applied.
  // A bundle is treated as one item: its discount is on the bundle row, not on the child items.
  // Items without these fields (old data) keep using their own tax / total.

  private itemHasDiscount(item: any): boolean {
    return Number(item?.discountAmount) > 0;
  }

  itemDiscount(item: any): number {
    return this.itemHasDiscount(item) ? Number(item.discountAmount) || 0 : 0;
  }

  itemTax(item: any): number {
    return this.itemHasDiscount(item) ? Number(item.discountedTax) || 0 : (+item?.tax || 0);
  }

  itemTotal(item: any): number {
    return this.itemHasDiscount(item) ? Number(item.discountedTotal) || 0 : (+item?.total || 0);
  }

  private amountFor(order: any, key: string): number {
    if (key === 'total') return this.itemTotal(order);
    if (key === 'tax') return this.itemTax(order);
    return parseFloat(order?.[key]) || 0;
  }

  private calculateDiscount(): number {
    if (!this.estimates) return 0;
    const sum = [...this.estimates, ...(this.optionalEstimates || [])]
      .filter((order: any) => order?.isInclude)
      .reduce((acc: number, order: any) => acc + this.itemDiscount(order), 0);
    return Number(sum.toFixed(2));
  }

  /** Subtotal before discount = (total - tax) + discount */
  get subtotalBeforeDiscount(): number {
    return (Number(this.totalAmount) || 0) - (Number(this.taxAmount) || 0) + (this.discountAmount || 0);
  }

  showImages(images: any) {
    this.commonService.openImageSliderModal(images)
  }

  reviewEstimate() {
    this.storageService.setItem('Estimates', this.estimates);
    this.storageService.setItem('OptionalEstimates', this.optionalEstimates);
    this.router.navigate([`${RouteConstant.estimateDetail}`], { queryParamsHandling: "merge", relativeTo: this.activatedRoute })
  }
  public approveEstimate() {
    this.commonService.collectSignature();
    this.commonService.confirmed().subscribe(data => {
      if (data) {
        this.approve(data);
      } else {
        this.approveAllFlag = false;
        this.approveAllRejected.emit(false);
      }
    })
  }
  approve(signature: any) {
    const allEstimates = [...this.estimates, ...this.optionalEstimates];
    const estimateIds = allEstimates
      .filter((estimate: any) => estimate.isInclude)
      .map((estimate: any) => estimate._id);
    let data = {
      estimateIds: estimateIds,
      status: 'Approved',
      signature: signature,
      opportunityId: this.activatedRoute.snapshot.queryParamMap.get('oppId') || this.activatedRoute.snapshot.queryParamMap.get('jobId')
    }
    this.loader.start();
    this.service.post(data, `${API_ROUTES.OPPORTUNITY.approveEstimate}`).pipe().subscribe(response => {
      if (response.status) {
        if (this.router.url.includes('opportunity-detail/review-estimate')) {
          this.router.navigate([`/services/jobs/job-detail`], { queryParams: { jobId: data.opportunityId } })
        } else {
          this.commonService.goBack();
        }
        this.loader.stop();
      } else {
        this.loader.stop();
        this.toastr.error(response.msg);
      }
    })
  }
  selectEstimate(e: any, id: any, estimate: any) {
    e.target.checked ? this.addSelectedEstimateId(id, estimate) : this.removeSelectedEstimateId(id, estimate)
    let data: Object = {
      isInclude: e.target.checked,
      estimateId: id,
      inspectionId: estimate.inspectionId,
      opportunityId: estimate.opportunityId
    };

    this.getDefaultStatus();
    this.isIncludeData.emit(data)
  }
  addSelectedEstimateId(id: any, estimate: any) {
    this.totalAmount = (parseFloat(this.totalAmount) + this.itemTotal(estimate)).toFixed(2);
    this.taxAmount = (parseFloat(this.taxAmount) + this.itemTax(estimate)).toFixed(2);
    this.discountAmount = Number((this.discountAmount + this.itemDiscount(estimate)).toFixed(2));
    this.approveEstimateIds.push(id);
  }
  removeSelectedEstimateId(id: any, estimate: any) {
    this.totalAmount = (parseFloat(this.totalAmount) - this.itemTotal(estimate)).toFixed(2);
    this.taxAmount = (parseFloat(this.taxAmount) - this.itemTax(estimate)).toFixed(2);
    this.discountAmount = Number(Math.max(0, this.discountAmount - this.itemDiscount(estimate)).toFixed(2));
    const updatedApproveEstimateIdsArray = this.approveEstimateIds.filter((e: any) => e !== id);
    this.approveEstimateIds = updatedApproveEstimateIdsArray;
  }
  viewEstimate(estimate: any) {
    this.commonService.setActiveEstimate(estimate);
  }

  fileBuffer: any;
  fileUrl: any;
  callApi() {
    const oppId = this.activatedRoute.snapshot.queryParamMap.get('oppId');
    const jobId = this.activatedRoute.snapshot.queryParamMap.get('jobId');
    const isEstimate = !this.work_order && !!oppId && !this.inspection;
    const isUnapproved = !this.work_order && !oppId && !this.inspection;

    const buildDataAndFetch = (includeImagesEstimate: any[] = [], usePost = false) => {
      this.loader.start();

      const data: any = {
        oppId: oppId || jobId
      };

      if (usePost === false) {
        data['imageIncludedItems'] = [];
      }

      const url = this.inspection
        ? `${API_ROUTES.OPPORTUNITY.previewInspection}`
        : this.work_order
          ? `${API_ROUTES.OPPORTUNITY.previewWorkOrder}`
          : `${API_ROUTES.OPPORTUNITY.previewEstimate}`;

      if (isEstimate) {
        data.type = 'estimate';
        data.imageIncludedItems = includeImagesEstimate;
        usePost = true;
      } else if (isUnapproved) {
        data.type = 'unapprovedItems';
        data.imageIncludedItems = includeImagesEstimate;
        usePost = true;
      }
      if (this.inspection) {
        data['inspectionSectionId'] = this.activatedRoute.snapshot.queryParamMap.get('insId');
      }
      const downloadName = this.inspection ? 'inspection_report'
        : isEstimate ? 'Estimate'
          : isUnapproved ? 'Unapproved Charges'
            : 'work_order.pdf';

      const request$ = usePost
        ? this.service.postPDF(data, url)
        : this.service.getPDF(data, url);

      request$.subscribe({
        next: (response: Blob) => {
          const fileURL = window.URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = downloadName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
        },
        error: (err) => {
          this.loader.stop();
          this.toastr.error(err?.msg || 'Download failed');
        },
        complete: () => this.loader.stop()
      });
    };

    const allEstimate = [...this.estimates, ...this.optionalEstimates];

    const hasEstimateImages = allEstimate.some(
      (estimate: any) => estimate?.images?.length > 0
    );
    if ((isEstimate || isUnapproved) && hasEstimateImages) {
      const approveEstimateIds = this.estimates
        .filter((estimate: any) => estimate.isEssential || estimate.isInclude)
        .map((estimate: any) => estimate._id)
        .filter((id, index, self) => self.indexOf(id) === index);

      const dialogRef = this.dialog.open(ImageIncludeComponent, {
        panelClass: 'collect-sign-dialog',
        backdropClass: 'blurBackground',
        width: '100%',
        data: {
          includeImageEstimate: true,
          approveEstimate: approveEstimateIds,
          allEstimate: [...this.estimates, ...this.optionalEstimates]
        }
      });

      dialogRef.afterClosed().subscribe(confirm => {
        if (confirm != null && confirm) {
          buildDataAndFetch(confirm?.approved?.length ? confirm.approved : [], true);
        }
      });
    } else {
      buildDataAndFetch();
    }
  }

  download() {
    // Create a link element for downloading the file
    const downloadLink: any = document.createElement('a');
    downloadLink.href = this.fileUrl;
    downloadLink.download = 'inspection_report';
    if (!this.inspection && !this.work_order && this.activatedRoute.snapshot.queryParamMap.get('oppId')) {
      downloadLink.download = 'Estimate'
    } else if (!this.inspection && !this.work_order && !this.activatedRoute.snapshot.queryParamMap.get('oppId')) {
      downloadLink.download = 'Unapproved Charges'
    }
    // Trigger a click event on the link to download the file
    downloadLink.click();
    this.loader.stop();
  }
  expandedBundles: Set<string> = new Set();
  getItemNumber(i: number): number {
    let count = 0;
    for (let j = 0; j <= i; j++) {
      count++;  // every entry (bundle or regular) counts as 1
    }
    return count;
  }
  /**
   * Toggle a bundle's expanded/collapsed state.
   * Called when the user clicks a bundle header row.
   */
  toggleBundle(bundleInstanceId: string): void {
    // if (this.expandedBundles.has(bundleInstanceId)) {
    //   this.expandedBundles.delete(bundleInstanceId);
    // } else {
    //   this.expandedBundles.add(bundleInstanceId);
    // }
  }

  /**
   * Returns true if the given bundle is currently expanded.
   * Used by *ngIf in the template to show/hide child rows.
   */
  isBundleExpanded(bundleInstanceId: string): boolean {
    return this.expandedBundles.has(bundleInstanceId);
  }

  onDragStarted(): void {
    // Collapse all expanded bundles when drag begins
    this.expandedBundles.clear(); // or whatever your expanded state is
  }
}
